import React from 'react'

import useKeyDown from '../hooks/use-key-down'
import Button from './button'
import {useSave} from './object-store'
import {useSaves} from './object-store'
import Portal from './portal'
import genId from '../utils/gen_id'
import {useDelete} from './object-store'


export default function Executor({executor, onClose, onRefresh}) {
    const save = useSave()
    const saves = useSaves()
    const remove = useDelete()
    const innerRef = React.useRef()
    const dateInputRef = React.useRef()
    const [rDay, setRDay] = React.useState(
        new Date().toISOString().split('T')[0]
    )

    const ref = React.useRef()
    const mouseDownRef = React.useRef(false)

    React.useEffect(() => {
        if (innerRef.current) {
            innerRef.current.focus()
            innerRef.current.select()
        }
        if (dateInputRef.current) {
            dateInputRef.current.focus()
        }
    }, [])

    useKeyDown(event => {
        if (event.key === 'Enter') execute()
        if (event.key === 'Escape') onClose()
    })

    const text = React.useMemo(() => {
        if (executor.action !== 'export') {return null}
        const parts = []
        let current = null

        executor.day.items.filter(i => i.model === 'wrktset').forEach(w => {
            if (current && current.exercise == w.exercise && current.weight == w.weight && current.count == w.count) {
                current.inSetCount += 1
            }
            else {
                if (current) {
                    parts.push(current)
                }
                current = {
                    inSetCount: 1,
                    exercise: w.exercise,
                    count: w.count,
                    weight: w.weight,
                }
            }
        })
        parts.push(current)
        return parts
            .map(p => {
                if (p.weight && p.weight != 0) {
                    return `${p.inSetCount} x ${p.count} x ${p.weight} ${p.exercise}`
                }
                return `${p.inSetCount} x ${p.count} x ${p.exercise}`
            })
            .join('\n')

    }, [executor.action, executor.day])

    function handleMouseDown(event) {
        if (event.target === ref.current) {
            mouseDownRef.current = true
        }
    }

    function handleCloseOverlay(event) {
        event.stopPropagation()
        if (event.target === ref.current && mouseDownRef.current && onClose) {
            onClose(event)
        }
        mouseDownRef.current = false
    }

    function execute() {
        if (executor.action === 'reschedule' && executor.wrktset) {
            save('wrktset', {
                id: executor.wrktset.id,
                day: rDay,
                rank: '-1',
            })
        }
        if (executor.action === 'reschedule' && executor.day) {
            ;['wrktitle', 'wrktset'].forEach(model => {
                const modelItems = executor.day.items.filter(i => i.model === model)
                if (modelItems.length === 0) { return }
                saves(model, modelItems.map(i => ({id: i.id, day: rDay, rank: '-1'})))
            })
        }
        if (executor.action === 'repeat' && executor.day) {
            const promises = executor.day.items.map(item => {
                const model = item.model
                return save(model, {
                    ...item,
                    model: undefined,
                    status: model === 'wrktset' ? undefined : item.status,
                    user: undefined,
                    id: genId(),
                    day: rDay,
                    done_at: model === 'wrktset' ? null : undefined,
                })
            })
            Promise.all(promises).then(onRefresh)
        }
        if (executor.action === 'delete' && executor.day) {
            const wrktsetIds = executor.day.items.filter(i => i.model === 'wrktset').map(i => i.id)
            const wrktitleIds = executor.day.items.filter(i => i.model === 'wrktitle').map(i => i.id)
            Promise.all([
                ...wrktsetIds.map(id => remove('wrktset', id)),
                ...wrktitleIds.map(id => remove('wrktitle', id)),
            ]).then(onRefresh)
        }
        if (executor.action === 'delete' && executor.wrktset) {
            remove('wrktset', executor.wrktset.id).then(onRefresh)
        }
        if (executor.action === 'reschedule' && executor.wrktsets) {
            saves('wrktset', executor.wrktsets.map(ws => ({id: ws.id, day: rDay, rank: '-1'})))
        }
        if (executor.action === 'reschedule' && executor.wrktitles && executor.wrktitles.length > 0) {
            saves('wrktitle', executor.wrktitles.map(wt => ({id: wt.id, day: rDay, rank: '-1'})))
        }
        if (executor.action === 'delete' && executor.wrktsets) {
            Promise.all(executor.wrktsets.map(ws => remove('wrktset', ws.id))).then(onRefresh)
        }
        onClose(executor.action === 'reschedule' ? rDay : undefined)
    }


    return <Portal>
        <div
            className="executor"
            onClick={handleCloseOverlay}
            ref={ref}
            onMouseDown={handleMouseDown}
        >
            <div className="executor__inner">
                {executor.action !== 'delete' && executor.action !== 'export' ? <input
                    type="date"
                    value={rDay}
                    onChange={e => setRDay(e.target.value)}
                    ref={dateInputRef}
                /> : null}
                {executor.action !== 'export' ?
                    <Button
                        onClick={execute}
                    >
                        {executor.action}
                    </Button>
                    : <textarea
                        style={{width: '80vw', height: '50vh'}}
                        value={text}
                        readOnly
                        ref={innerRef}
                    />
                }
            </div>
        </div>
    </Portal>
}
